import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// ScrollTriggerプラグインを登録
gsap.registerPlugin(ScrollTrigger);

// スライドアニメーションの初期化
export function initSlideAnimation() {
  // slide01から07までのIDと背景色を配列で管理
  const slideData = [
    { id: 'slide01', bgColor: '#eee9e6' },
    { id: 'slide02', bgColor: '#dcd6d2' },
    { id: 'slide03', bgColor: '#b4aeb1' },
    { id: 'slide04', bgColor: '#9d8e87' },
    { id: 'slide05', bgColor: '#b0778c' },
    { id: 'slide06', bgColor: '#6e4a55' },
    { id: 'slide07', bgColor: '#6e4a55' }
  ];

  // thoughtBg要素を取得
  const thoughtBgElement = document.getElementById('thoughtBg');
  
  slideData.forEach((slideInfo) => {
  const slideElement = document.getElementById(slideInfo.id);
  if (!slideElement) return;

  const image = slideElement.querySelector('img');
  const texts = slideElement.querySelectorAll('p');
  const elementsToAnimate = [];
  if (image) elementsToAnimate.push(image);
  texts.forEach(text => elementsToAnimate.push(text));
  if (elementsToAnimate.length === 0) return;

  gsap.set(elementsToAnimate, { opacity: 0 });

  // slide01〜slide05は長め（200%）、それ以外は100%
  const scrollEnd = (["slide01","slide02","slide03","slide04","slide05"].includes(slideInfo.id))
    ? "+=200%"  // ← 2画面分
    : "+=100%"; // ← 1画面分

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: slideElement,
      start: "bottom bottom",
      end: scrollEnd,
      pin: true,
      pinSpacing: true,
      scrub: true
    }
  });

  if (thoughtBgElement) {
    tl.to(thoughtBgElement, { backgroundColor: slideInfo.bgColor, duration: 0.3, ease: "none" }, 0);
  }

  tl.fromTo(elementsToAnimate, 
  { opacity: 0 }, 
  { opacity: 1, duration: 0.5, ease: "none" }, 
  0.1
)
.to(elementsToAnimate, 
  { opacity: 0, duration: 0.5, ease: "none" }, 
  1.2 // ← 0.6 から 1.2 に変更
);

});

}

// スライドから出る時のアニメーション（opacityのみ）
function exitSlideAnimation(elements) {
  // 既存のアニメーションを停止
  gsap.killTweensOf(elements);
  
  gsap.to(elements, {
    opacity: 0,
    duration: 0.6,
    ease: "power2.in"
  });
}

// ScrollTriggerのリフレッシュ関数
export function refreshScrollTrigger() {
  ScrollTrigger.refresh();
}

// クリーンアップ関数
export function cleanupSlideAnimation() {
  ScrollTrigger.getAll().forEach(trigger => trigger.kill());
}